import { gql, type TypedDocumentNode } from "@apollo/client";

export type InteractionTopicInput = {
  name: string;
  subtopics: string[];
  code: string | null;
  defaultPrivate: boolean | null;
};

export type InteractionTopicConfig = {
  department: string;
  lockVersion: number;
  topics: InteractionTopicInput[];
};

export type InteractionTopicConfigsQueryResponse = {
  interactionTopicConfigs: InteractionTopicConfig[];
};

export const INTERACTION_TOPIC_CONFIGS_QUERY: TypedDocumentNode<InteractionTopicConfigsQueryResponse> = gql`
  query InteractionTopicConfigs {
    interactionTopicConfigs {
      department
      lockVersion
      topics {
        name
        subtopics
        code
        defaultPrivate
      }
    }
  }
`;

export const INTERACTION_TOPIC_DEPARTMENTS = [
  { value: "career_services", label: "Career Services" },
  { value: "recruiting", label: "Recruiting" },
  { value: "player_engagement", label: "Player Engagement" },
  { value: "section", label: "Section" },
  { value: "education", label: "Education" },
  { value: "membership_services", label: "Membership Services" }
] as const;

export type InteractionTopicDepartment = (typeof INTERACTION_TOPIC_DEPARTMENTS)[number]["value"];

export const INTERACTION_TOPIC_DEPARTMENT_PARAM = "department";

export const OTHER_TOPIC = "Other";

export function parseInteractionTopicDepartment(value: unknown): InteractionTopicDepartment {
  if (typeof value === "string" && INTERACTION_TOPIC_DEPARTMENTS.some((dept) => dept.value === value)) {
    return value as InteractionTopicDepartment;
  }
  return "career_services";
}
